import assign from 'lodash/assign';

import AddressDetails from 'app/shared/model/AddressDetails';
import DispatchConstants from 'app/shared/constants/DispatchConstants';

const initState = () => (AddressDetails({}));

const details = (state = initState(), action = {}) => {
    const { type, payload } = action;

    switch (type) {
        case DispatchConstants.ADDRESS_DETAILS:
            return assign({}, state, payload);

        default:
            return state;
    }
};

export default details;
